/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'link-arrow': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 10',
    data: '<path d="M14 11L19 6L14 1" stroke="#005EB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="svg-stroke"/><path d="M19 6L1 6" stroke="#005EB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="svg-stroke"/>'
  }
})